import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useCookieConsent } from "@/context/CookieConsentContext";
import { LEGAL } from "@/constants/testIds";

export default function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, openPreferences } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      data-testid={LEGAL.cookieBanner}
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
    >
      <div className="mx-auto max-w-4xl overflow-hidden rounded-2xl border border-border bg-white shadow-[0_20px_60px_-15px_rgba(0,0,0,0.35)]">
        <div className="flex flex-col gap-5 p-5 sm:p-6 md:flex-row md:items-center">
          <div className="flex-1">
            <div className="mb-2 flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-accent text-primary">
                <Cookie className="h-5 w-5" />
              </span>
              <h3 className="font-display text-xl font-semibold text-foreground">Tu privacidad importa</h3>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Utilizamos cookies propias necesarias para el funcionamiento del sitio y, con tu consentimiento, cookies
              analíticas para medir el uso de la web. Puedes aceptarlas todas, rechazarlas o configurarlas. Más
              información en nuestra{" "}
              <Link to="/politica-de-cookies" className="font-semibold text-primary underline underline-offset-2">
                Política de Cookies
              </Link>
              .
            </p>
          </div>

          <div className="flex flex-col gap-2.5 sm:flex-row md:w-auto md:flex-col md:gap-2.5">
            <button
              onClick={acceptAll}
              data-testid={LEGAL.cookieAcceptAll}
              className="rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground shadow-sm transition-transform hover:-translate-y-0.5 hover:shadow-lg"
            >
              Aceptar todas
            </button>
            <button
              onClick={rejectAll}
              data-testid={LEGAL.cookieRejectAll}
              className="rounded-full border border-border bg-white px-6 py-2.5 text-sm font-bold text-foreground transition-colors hover:bg-secondary"
            >
              Rechazar
            </button>
            <button
              onClick={openPreferences}
              data-testid={LEGAL.cookieConfigure}
              className="rounded-full px-6 py-2.5 text-sm font-bold text-primary transition-colors hover:bg-accent"
            >
              Configurar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
